import React, { useRef, useState } from 'react';
import { useToast } from 'react-native-toast-notifications';
import { StyleSheet, View } from 'react-native';
import { Page, BText, showToast, BLink } from '../../components';
import { useAppDispatch } from '../../hooks';
import { Input, Button, FormContainer, ButtonContainer, TextContainer } from '../../components/Form';
import authService from '../../services/authService';
import { setLoading } from '../../store/portal/portalActions';

export const ForgetPassword = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const inputMobileNo = useRef<HTMLInputElement>(null);
  const inputEmail = useRef<HTMLInputElement>(null);

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');

  const getPassBtn = async () => {
    dispatch(setLoading(true));

    const mobileNo = inputMobileNo.current?.value;
    const email = inputEmail.current?.value;

    if (mobileNo && email) {
      let res = await authService.forgotPassword(mobileNo, email);
      console.log(res);

      setPassword(res.data);
      setShowPassword(true);
      dispatch(setLoading(false));
    } else {
      showToast(toast, { message: 'Please key in mobile number and email.', type: 'error' });
    }
  };

  return (
    <Page title={'Forget Password'}>
      {!showPassword && (
        <FormContainer title="">
          <Input
            label={'Mobile Number'}
            id="mobileNo"
            value={''}
            //schemaObject={UserInputSchema}
            //schemaContext={{ isNew: true }}
            ref={inputMobileNo}
          />
          <Input
            label={'Email'}
            id="email"
            type="email"
            value={''}
            //schemaObject={UserInputSchema}
            //schemaContext={{ isNew: true }}
            ref={inputEmail}
          />
          <ButtonContainer>
            <Button onPress={() => getPassBtn()}>Reset Password</Button>
          </ButtonContainer>

          <TextContainer align="center">
            <BLink to={{ screen: 'login' }}>Login</BLink>
            <BText> | </BText>
            <BLink to={{ screen: 'register' }}>Register</BLink>
          </TextContainer>
        </FormContainer>
      )}
      {showPassword && (
        <View style={styles.sampleShowPwdContainer}>
          <BText style={styles.sampleTitle}>Your password</BText>

          <View style={styles.sampleContent}>
            Forgot password for demo purpose (pending for email system)
            {'\n'}
            Password: {password}
          </View>
        </View>
      )}
    </Page>
  );
};

const styles = StyleSheet.create({
  sampleShowPwdContainer: {},
  sampleTitle: {
    fontSize: 16,
  },
  sampleContent: {},
});
